'use client';

import { useSavedVolume } from 'src/hooks/savedVolume/useSavedVolume';
import { LOCATION } from 'src/hooks/filters/constants';

const useIsAdvancedSearchActive = (): boolean => {
  const { appliedSavedVolume } = useSavedVolume(LOCATION.DISCOVERY);

  return appliedSavedVolume?.volumeType === 'advancedSearch';
};

export default useIsAdvancedSearchActive;
